import { gql } from '@apollo/client';
import { mutation } from 'services/graphql';

const changeUsersAccessOnSurfaceMutation = gql`
  mutation changeUsersAccessOnSurface(
    $input: ChangeUsersAccessOnSurfaceInput!
  ) {
    changeUsersAccessOnSurface(input: $input) {
      data
      error
      success
    }
  }
`;

export default mutation(changeUsersAccessOnSurfaceMutation);
